export default "__VITE_ASSET__7dc43607__"